<script>
import AjaxLoad from "@/components/commonComponents/AjaxLoad.vue";
import VDataTableWordCloudWords from "@/components/VDataTable/VDataTableWordCloudWords.vue";
import _ from "lodash";
import ComponentsKeys from "@/mixins/ComponentsKeys";
import WordCloudsWordsModal from "@/components/WordClouds/WordCloudsWordsModal.vue";
import Comments from "@/components/commonComponents/Comments.vue";
import WordCloud from '@/components/WordClouds/WordCloud.vue';
import NumberRangeCombobox from '@/components/WordClouds/NumberRangeCombobox';
import ColorCombobox from '@/components/WordClouds/ColorCombobox';
import History from "@/components/commonComponents/History.vue";
import IsolatedRender from "@/components/commonComponents/IsolatedRender.vue";
import VCurrencyInput from "@/components/commonComponents/VCurrencyInput.vue";
import VFormModified from "@/components/commonComponents/VFormModified.vue";
import CommonRules from "@/mixins/CommonRules";
import Languages from "@/mixins/dictionaries/Languages";

// const bg = 'data:image/webp;base64,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';

export default {
    name: "ForumEventWordCloud",
    components: {
        VFormModified,
        VCurrencyInput,
        IsolatedRender,
        History,
        Comments,
        WordCloudsWordsModal,
        VDataTableWordCloudWords,
        AjaxLoad,
        WordCloud,
        NumberRangeCombobox,
        ColorCombobox,
    },
    mixins: [
        ComponentsKeys,
        CommonRules,
        Languages,
    ],
    data() {
        return {
            original: null,
            data: {},
            resolved: false,
            dictionaries: {
                spirals: [
                    {
                        id: 'archimedean',
                        text: 'Archimedean',
                    },
                    {
                        id: 'rectangular',
                        text: 'Rectangular',
                    },
                ],
                fontSizes: [
                    {
                        id: 'log',
                        text: 'log n',
                        mapperFn: word => Math.log(word.value),
                    },
                    {
                        id: 'sqrt',
                        text: '√n',
                        mapperFn: word => Math.sqrt(word.value),
                    },
                    {
                        id: 'linear',
                        text: 'n',
                        mapperFn: word => word.value,
                    },
                ],
            },
            componentsKeys: {
                wordCloudWordsModal: this.getRandomKey('wordCloudWordsModal')
            },
            onWordClick: (word) => {
                document.querySelector('.wordcloud-word-id-' + word.id)
                    .scrollIntoView({
                        behavior: 'smooth'
                    });
            },
            tab: null,
            panel: [0],
            paddingsInputOptions: {
                valueRange: {min: 0, max: 500},
                precision: 0,
            },
            qtyInputOptions: {
                valueRange: {min: 1, max: 500},
                precision: 0,
            },
            fontSizeInputOptions: {
                valueRange: {min: 0.1, max: 10},
                precision: 1,
            },
            rotateItems: [-90,-60,-45,-30,-15,0,15,30,45,60,90],
            wasModified: false,
            isSubmit: false,
            isValid: false,
        };
    },
    computed: {
        idProject() {
            return this.$store.getters.breadCrumbs.event?.EPS_PROJECT_ID?.VALUE || null;
        },
        idWordclouds() {
            return this.$route.params.ID_WORDCLOUDS;
        },
        isActive() {
            return !!(this.idProject && this.idWordclouds);
        },
        wordcloudQtyDebounced: {
            get() {
                return this.data.qty;
            },
            set: _.debounce(function (v) {
                this.data.qty = v || 0;
            }, 400),
        },
        effectiveWordsByLanguageRu() {
            return this.getEffectiveWordsByLanguage(this.data?.words, 'ru', this.data?.qty);
        },
        effectiveWordsByLanguageEn() {
            return this.getEffectiveWordsByLanguage(this.data?.words, 'en', this.data?.qty);
        },
        wordcloudMargin() {
            const data = this.data;
            return {
                top: data.margin_top || 0,
                right: data.margin_right || 0,
                bottom: data.margin_bottom || 0,
                left: data.margin_left || 0,
            };
        },
        saveDebounced() {
            return _.debounce(this.save, 2000);
        },
        url() {
            return this.$apiUrl.getWordCloudUrl({id_project: this.idProject, id_wordclouds: this.idWordclouds})
        },
        fontSizeMapper() {
            return this.data?.font_size ? _.find(this.dictionaries.fontSizes, {id: this.data?.font_size})?.mapperFn : this.dictionaries.fontSizes[0].mapperFn;
        },
        permissions() {
            return this.original?.permissions || {};
        },
        permissionsWords() {
            return {canCreate: this.permissions?.canUpdate};
        },
        isCanSubmit() {
            return this.permissions?.canUpdate && !this.isSubmit && this.wasModified && this.resolved && this.isValid;
        },
        isDisabled() {
            return this.isSubmit || !this.resolved;
        },
        colorScheme() {
            return (Array.isArray(this.data?.colors) && !!this.data.colors.length) ? this.data.colors : null;
        },
        font() {
            return [this.data.fontFamily, this.idWordclouds].join('');
        },
    },
    watch: {
        data: {
            handler() {
                this.saveDebounced();
            },
            deep: true,
        },
    },
    methods: {
        getWordsByLanguage(items, language) {
            let pos = 0;
            return _.chain(items).cloneDeep().filter({language}).orderBy(['value'], ['desc']).map(function (v) {
                v.num = ++pos;
                return v;
            }).value();
        },
        getEffectiveWordsByLanguage(items, language, limit) {
            return _.chain(this.getWordsByLanguage(items, language)).filter(v => ((v.value > 0) && (v.num <= limit))).value();
        },
        doShowModal(id, data = {}) {
            this.$refs.wordCloudWordsModal
                .show(id, data)
                .then((result) => {
                    if (result !== false) {
                        this.$refs.ajax.load();
                        this.$refs.history?.load();
                    }
                })
                .finally(() => {
                    this.updateComponentKey('wordCloudWordsModal');
                });
        },
        onDblClickRow(e, {item}) {
            this.doShowModal(item.id);
        },
        onClickAddRow(data = {}) {
            this.doShowModal(0, data);
        },
        save() {
            if (!this.isCanSubmit) {
                return;
            }
            this.isSubmit = true;
            this.$api.put(this.url, this.data)
                .then(response => {
                    /**
                     * data или original
                     * обновляем данные облака из ответа на запрос обновления.
                     * но т.к. ответ "облегчен"(содержит пустые words: [], background: "", background_opacity)
                     * их надо сохранить/восстановить из оригинальной записи.
                     * восстанавливаем из original, а не data, что бы если по какой-либо причине
                     * ответ не содержит полный набор полей, то недостающие поля сбросятся в исходное состояние.
                     * эта будет сигнализировать что что-то не так.
                     **/
                    const backgroundsFields = this.dictionaries.languages.map(v => 'background_' + v.id),
                        ommitFields = ['words', 'background_opacity'].concat(backgroundsFields);
                    this.original = Object.assign(
                        {},
                        this.original,
                        _.omit(response.data.data, ommitFields)
                    );
                    this.$refs.history?.load();
                })
                .catch(this.notifyError)
                .finally(() => {
                    this.isSubmit = false;
                })

        },
        isDisabledField(field) {
            return this.isDisabled || !(this.permissions?.canUpdate && this.permissions?.isEditableField[field]);
        },
    },
}
</script>

<template>
    <ajax-load
        ref="ajax"
        v-model="original"
        :active="isActive"
        :url="url"
        :transform="response => response.data.data"
        :resolved.sync="resolved"
        v-slot="{active}"
    >
        <v-form-modified
            v-model="isValid"
            :original="original"
            :modified.sync="data"
            :was-modified.sync="wasModified"
        >
            <v-container fluid class="down-top-padding">
                <v-row :no-gutters="false">
                    <v-col>
                        <v-card>
                            <v-toolbar flat>
                                <v-toolbar-title>
                                    Облако смыслов
                                    <template v-if="data.date_start">
                                        <template v-if="data.date_start !== data.date_end">
                                            {{ data.date_start | moment('DD.MM.Y') }}
                                            -
                                            {{ data.date_end | moment('DD.MM.Y') }}
                                        </template>
                                        <template v-else>
                                            {{ data.date_start | moment('DD.MM.Y') }}
                                        </template>
                                    </template>
                                </v-toolbar-title>
                            </v-toolbar>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-card>
                            <v-tabs v-model="tab">
                                <v-tab tab-value="common">Общее</v-tab>
                                <v-tab tab-value="history">История</v-tab>
                            </v-tabs>
                            <v-tabs-items v-model="tab">
                                <v-tab-item value="common">

                                    <v-container fluid class="down-top-padding">
                                        <v-row>
                                            <v-col :cols="12" :sm="6">
                                                <!--
                                                + Управление настройками, rotate, цвет и пр...
                                                + Возможность выводить не все слова, а top N слов... В т.ч. сюда не должны идти слова с 0, в принципе...
                                                + Фоновое изображение? См. https://cdnweb.roscongress.ru/upload/medialibrary/7dc/43sxvj7vauxqvq4kx87j1phwwy8iy1yt/REN_oblako_ru_all_2.png?1727482753265528
                                                + Download...
                                                @TODO Это умеет выкидывать некоторые слова, когда это станет критичным - см. https://github.com/jasondavies/d3-cloud/issues/36
                                                   Несмотря на limit оно, при, например, limit=100, рисует меньше записей - зависит от размера w*h и шрифта...
                                                -->

                                                <isolated-render v-slot="{}">
                                                    <word-cloud
                                                        width="1280"
                                                        height="720"
                                                        :data="effectiveWordsByLanguageRu"
                                                        :font="font"
                                                        :fontContent="data?.font"
                                                        :fontScale="data?.font_scale"
                                                        :onWordClick="onWordClick"
                                                        :padding="data?.words_padding"
                                                        :fontSizeMapper="fontSizeMapper"
                                                        :rotate="data.rotate || 0"
                                                        :backgroundImage="data?.background_ru"
                                                        :background-image-opacity="data?.background_opacity"
                                                        :margin="wordcloudMargin"
                                                        :loading="!resolved && !!active"
                                                        :spiral="data.spiral"
                                                        :colors="colorScheme"
                                                        ref="firstCloud"
                                                    ></word-cloud>
                                                </isolated-render>
                                            </v-col>
                                            <v-col :cols="12" :sm="6">
                                                <isolated-render v-slot="{}">
                                                    <word-cloud
                                                        width="1280"
                                                        height="720"
                                                        :data="effectiveWordsByLanguageEn"
                                                        :font="font"
                                                        :fontContent="data?.font"
                                                        :fontScale="data?.font_scale"
                                                        :onWordClick="onWordClick"
                                                        :padding="data?.words_padding"
                                                        :fontSizeMapper="fontSizeMapper"
                                                        :rotate="data.rotate || 0"
                                                        :backgroundImage="data?.background_en"
                                                        :background-image-opacity="data?.background_opacity"
                                                        :margin="wordcloudMargin"
                                                        :loading="!resolved && !!active"
                                                        :spiral="data.spiral"
                                                        :colors="colorScheme"
                                                        ref="secondCloud"
                                                    ></word-cloud>
                                                </isolated-render>
                                            </v-col>
                                        </v-row>

                                        <v-expansion-panels
                                            multiple
                                            focusable
                                            class="py-4"
                                            v-model="panel"
                                        >
                                            <v-expansion-panel>
                                                <v-expansion-panel-header class="px-4">Базовые параметры
                                                </v-expansion-panel-header>
                                                <v-expansion-panel-content>
                                                    <isolated-render v-slot="{}">
                                                        <v-row :no-gutters="false">
                                                            <v-col>
                                                                <v-currency-input
                                                                    v-model.number="wordcloudQtyDebounced"
                                                                    label="Макс. кол-во слов"
                                                                    :options="qtyInputOptions"
                                                                    :disabled="isDisabledField('qty')"
                                                                ></v-currency-input>
                                                            </v-col>
                                                        </v-row>
                                                    </isolated-render>
                                                </v-expansion-panel-content>
                                            </v-expansion-panel>

                                            <v-expansion-panel>
                                                <v-expansion-panel-header class="px-4">Отступы
                                                </v-expansion-panel-header>
                                                <v-expansion-panel-content>
                                                    <isolated-render v-slot="{}">
                                                        <v-row :no-gutters="false">
                                                            <v-col>
                                                                <v-currency-input
                                                                    v-model.number="data.margin_left"
                                                                    label="…слева"
                                                                    hide-details
                                                                    :options="paddingsInputOptions"
                                                                    :suffix="data.margin_left ? 'px' : null"
                                                                    :disabled="isDisabledField('margin_left')"
                                                                ></v-currency-input>
                                                            </v-col>
                                                            <v-col>
                                                                <v-currency-input
                                                                    v-model.number="data.margin_right"
                                                                    label="…справа"
                                                                    hide-details
                                                                    :options="paddingsInputOptions"
                                                                    :suffix="data.margin_right ? 'px' : null"
                                                                    :disabled="isDisabledField('margin_right')"
                                                                ></v-currency-input>
                                                            </v-col>
                                                            <v-col>
                                                                <v-currency-input
                                                                    v-model.number="data.margin_top"
                                                                    label="…сверху"
                                                                    hide-details
                                                                    :options="paddingsInputOptions"
                                                                    :suffix="data.margin_top ? 'px' : null"
                                                                    :disabled="isDisabledField('margin_top')"
                                                                ></v-currency-input>
                                                            </v-col>
                                                            <v-col>
                                                                <v-currency-input
                                                                    v-model.number="data.margin_bottom"
                                                                    label="…снизу"
                                                                    hide-details
                                                                    :options="paddingsInputOptions"
                                                                    :suffix="data.margin_bottom ? 'px' : null"
                                                                    :disabled="isDisabledField('margin_bottom')"
                                                                ></v-currency-input>
                                                            </v-col>
                                                            <v-col>
                                                                <v-currency-input
                                                                    v-model.number="data.words_padding"
                                                                    label="…вокруг слов"
                                                                    hide-details
                                                                    :options="paddingsInputOptions"
                                                                    :suffix="data.words_padding ? 'px' : null"
                                                                    :disabled="isDisabledField('words_padding')"
                                                                ></v-currency-input>
                                                            </v-col>
                                                        </v-row>
                                                    </isolated-render>
                                                </v-expansion-panel-content>
                                            </v-expansion-panel>

                                            <v-expansion-panel>
                                                <v-expansion-panel-header class="px-4">Цветовая схема
                                                </v-expansion-panel-header>
                                                <v-expansion-panel-content>
                                                    <isolated-render v-slot="{}">
                                                        <v-row>
                                                            <v-col>
                                                                <color-combobox
                                                                    v-model="data.colors"
                                                                    :disabled="isDisabledField('colors')"
                                                                    label="Цвета"
                                                                    multiple
                                                                    small-chips
                                                                    clearable
                                                                    placeholder="Например, #FFFFFF, rgb(0, 0, 0), rgba(255, 0, 0, 0.5), silver..."
                                                                ></color-combobox>
                                                            </v-col>
                                                        </v-row>
                                                    </isolated-render>
                                                </v-expansion-panel-content>
                                            </v-expansion-panel>

                                            <v-expansion-panel>
                                                <v-expansion-panel-header class="px-4">Вращение
                                                </v-expansion-panel-header>
                                                <v-expansion-panel-content>
                                                    <isolated-render v-slot="{}">
                                                        <v-row>
                                                            <v-col>
                                                                <number-range-combobox
                                                                    v-model="data.rotate"
                                                                    :items.sync="rotateItems"
                                                                    :disabled="isDisabledField('rotate')"
                                                                    postfix="°"
                                                                    label="Углы"
                                                                    hide-selected
                                                                    multiple
                                                                    small-chips
                                                                    sorted
                                                                    clearable
                                                                ></number-range-combobox>
                                                            </v-col>
                                                        </v-row>
                                                    </isolated-render>
                                                </v-expansion-panel-content>
                                            </v-expansion-panel>

                                            <v-expansion-panel>
                                                <v-expansion-panel-header class="px-4">Экспертные настройки
                                                </v-expansion-panel-header>
                                                <v-expansion-panel-content>
                                                    <isolated-render v-slot="{}">
                                                        <v-row :no-gutters="false">
                                                            <v-col>
                                                                <v-autocomplete
                                                                    v-model="data.spiral"
                                                                    :items="dictionaries.spirals"
                                                                    :disabled="isDisabledField('spiral')"
                                                                    item-value="id"
                                                                    item-text="text"
                                                                    label="Спираль"
                                                                    hide-details
                                                                ></v-autocomplete>
                                                            </v-col>
                                                            <v-col>
                                                                <v-autocomplete
                                                                    v-model="data.font_size"
                                                                    :items="dictionaries.fontSizes"
                                                                    :disabled="isDisabledField('font_size')"
                                                                    item-value="id"
                                                                    item-text="text"
                                                                    label="Функция размера шрифта"
                                                                    hide-details
                                                                ></v-autocomplete>
                                                            </v-col>
                                                            <v-col>
                                                                <v-currency-input
                                                                    v-model.number="data.font_scale"
                                                                    label="Масштаб шрифта"
                                                                    hide-details
                                                                    :options="fontSizeInputOptions"
                                                                    :disabled="isDisabledField('font_scale')"
                                                                ></v-currency-input>
                                                            </v-col>
                                                        </v-row>
                                                    </isolated-render>

                                                </v-expansion-panel-content>
                                            </v-expansion-panel>
                                        </v-expansion-panels>

                                        <v-row :no-gutters="false">
                                            <v-col v-for="language in dictionaries.languages"
                                                   :key="language.id">
                                                <v-card height="100%">
                                                    <v-data-table-word-cloud-words
                                                        :heading="language.name"
                                                        :items="getWordsByLanguage(data?.words, language.id)"
                                                        :limit="data?.qty"
                                                        :loading="!resolved && !!active"
                                                        :footer-props="{itemsPerPageOptions: [-1]}"
                                                        :custom-permissions="permissionsWords"
                                                        @dblclick:row="onDblClickRow"
                                                        @click:add="onClickAddRow({language: language.id})"
                                                        @click:reload="() => $refs.ajax.load()"
                                                        search=""
                                                        with-toolbar
                                                    ></v-data-table-word-cloud-words>
                                                </v-card>
                                            </v-col>

                                        </v-row>

                                        <word-clouds-words-modal
                                            ref="wordCloudWordsModal"
                                            :key="componentsKeys.wordCloudWordsModal"
                                            :id-project="idProject"
                                            :id-wordclouds="idWordclouds"
                                        ></word-clouds-words-modal>

                                    </v-container>
                                </v-tab-item>
                                <v-tab-item value="history">
                                    <history
                                        ref="history"
                                        :url="$apiUrl.getWordCloudHistoryUrl({id_project: idProject, id_wordclouds: idWordclouds})"
                                        :table-props="{footerProps:{itemsPerPageOptions: [100]}, groupBy:null}"
                                    ></history>
                                </v-tab-item>
                            </v-tabs-items>
                        </v-card>

                    </v-col>
                    <v-col cols="3">
                        <v-card height="100%">
                            <v-toolbar flat>
                                <v-toolbar-title>Комментарии</v-toolbar-title>
                            </v-toolbar>
                            <comments
                                v-if="isActive"
                                :url="$apiUrl.getWordCloudComments({id_project: idProject, id_wordclouds: idWordclouds})"
                            ></comments>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-form-modified>
    </ajax-load>
</template>

<style scoped lang="scss">
::v-deep .wordCloud {
    line-height: 0;

    g {
        text {
            cursor: pointer;
        }
    }
}

::v-deep {
    .svg-preview {
        .v-card__actions {
            border-top: 1px solid silver;
        }
    }

    .v-expansion-panels {
        &.v-expansion-panels--focusable {
            .v-expansion-panel--active {
                .v-expansion-panel-header--active {
                    font-size: 1.25rem;
                    line-height: 1.5;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;

                    &:before {
                        opacity: 0;
                    }

                    &:focus {
                        opacity: 1;
                    }
                }
            }

            .v-expansion-panel-content__wrap {
                padding-left: 16px !important;
                padding-right: 16px !important;
            }
        }
    }

    .v-tabs {
        border-bottom: 1px solid #c0c0c044;
    }
}
</style>